module.exports = {
      id: "foursquare-usage",
      viewBox: "0 0 46 64",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#foursquare",
      toString: function () {
        return this.url;
      }
    }